import { Button } from '@/modules/ui/components/button/Button';
import {
  ConfirmDeleteDialog,
  type ConfirmDeleteDialogProps,
} from '@/modules/ui/components/confirm-delete-dialog/ConfirmDeleteDialog';

export const DeleteButton = (props: ConfirmDeleteDialogProps) => {
  return (
    <ConfirmDeleteDialog
      {...props}
      trigger={<Button variant="outline">Delete</Button>}
    />
  );
};
